/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from '@material-ui/core/Link';
import clsx from 'clsx';
import React from 'react';
import useStyles from './ButtonStyles';
export default function LinkButton({
  children,
  onClick,
  className
}) {
  const {
    linkButton
  } = useStyles();
  return /*#__PURE__*/React.createElement(Link, {
    component: "button",
    variant: "body1",
    onClick: onClick,
    className: clsx(linkButton, className),
    underline: "always"
  }, children);
}